import { getConfigData, getRequestData, getVariantValue, serverOrClient } from '@udemy/shared-utils';
import { udLink } from '@udemy/ud-data';
import { UDEMY_BUSINESS_PATH, BENESSE_BASE_URL, UDEMYKOREA_BUSINESS_DEMO_PATH, UDEMYKOREA_BUSINESS_PATH, KOREA_DEMO_REQUEST_PATHS, UTM_QUERY_PARAM_MKTO_FIELDS } from '../constants';
function getMarketoUTMParameters() {
  var _serverOrClient$globa;
  // Extracts Marketo's UTM parameters and forwards them as query parameters
  const keys = Object.keys(UTM_QUERY_PARAM_MKTO_FIELDS);
  const query = new URLSearchParams(((_serverOrClient$globa = serverOrClient.global.location) === null || _serverOrClient$globa === void 0 ? void 0 : _serverOrClient$globa.search) || '');
  const forward = {};
  for (const utm of keys) {
    if (query.has(utm)) {
      forward[utm] = query.get(utm);
    }
  }
  return forward;
}
export function toBusinessUdemy(path, params = {}, isOnsiteRequestDemo = false, globalOverrides) {
  var _globalOverrides$requ, _globalOverrides$Conf;
  const udRequest = (_globalOverrides$requ = globalOverrides === null || globalOverrides === void 0 ? void 0 : globalOverrides.request) !== null && _globalOverrides$requ !== void 0 ? _globalOverrides$requ : getRequestData();
  const udConfig = (_globalOverrides$Conf = globalOverrides === null || globalOverrides === void 0 ? void 0 : globalOverrides.Config) !== null && _globalOverrides$Conf !== void 0 ? _globalOverrides$Conf : getConfigData();
  let baseUrl = UDEMY_BUSINESS_PATH;
  if (path) {
    baseUrl += `${path}/`;
  }
  if (udRequest.locale === 'ja_JP' && path !== 'sign-up') {
    baseUrl = BENESSE_BASE_URL;
  }
  if (udRequest.locale === 'ko_KR') {
    if (KOREA_DEMO_REQUEST_PATHS.includes(path !== null && path !== void 0 ? path : '')) {
      baseUrl = UDEMYKOREA_BUSINESS_DEMO_PATH;
    } else {
      baseUrl = UDEMYKOREA_BUSINESS_PATH;
    }
  }

  // Onsite demo request experiment
  if (path === 'request-demo' && udRequest.locale !== 'ja_JP' && udRequest.locale !== 'ko_KR' && udRequest.locale !== 'de_DE') {
    var _udConfig$price_count;
    if (getVariantValue('sw', 'onsite_demo_form', false) || isOnsiteRequestDemo) {
      var _serverOrClient$globa2;
      return udLink.to('organization-growth/request-demo', null, {
        ...params,
        locale: udRequest.locale,
        next: encodeURIComponent((_serverOrClient$globa2 = serverOrClient.global.location) === null || _serverOrClient$globa2 === void 0 ? void 0 : _serverOrClient$globa2.href) || '',
        ...getMarketoUTMParameters()
      });
    }
    if (((_udConfig$price_count = udConfig.price_country) === null || _udConfig$price_count === void 0 ? void 0 : _udConfig$price_count.id) === 'IN') {
      baseUrl = `${UDEMY_BUSINESS_PATH}request-demo-in-mx/`;
    } else {
      baseUrl = `${UDEMY_BUSINESS_PATH}request-demo-mx/`;
    }
  }
  const urlSearchParams = new URLSearchParams({
    ...params,
    locale: udRequest.locale
  });
  return `${baseUrl}?${urlSearchParams.toString()}`;
}
//# sourceMappingURL=links.js.map